import { Beer, SavedBeerFlight } from "../data/types";

const STORAGE_KEY = "user-flight-history";
const MAX_HISTORY = 20;

const flightsAreEqual = (a: Beer[], b: Beer[]): boolean =>
  a.length === b.length && a.every((beer, i) => beer.id === b[i]?.id);

export const getFlightHistory = (): SavedBeerFlight[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as SavedBeerFlight[];
    return parsed.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  } catch {
    return [];
  }
};

export const saveFlightToHistory = (
  beers: (Beer | null)[]
): SavedBeerFlight | null => {
  if (!beers.every((beer) => beer !== null)) return null;

  const beerList = beers as Beer[];
  const history = getFlightHistory();

  if (
    history.length > 0 &&
    flightsAreEqual(history[0].beers, beerList)
  ) {
    return null;
  }

  const saved: SavedBeerFlight = {
    id: crypto.randomUUID(),
    beers: beerList,
    createdAt: new Date().toISOString(),
  };

  const updated = [saved, ...history].slice(0, MAX_HISTORY);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return saved;
};
